import * as Yup from "yup";
import { FIELD_REQUIRED_MESSAGE } from "../utils/validations";

export const accessInitialValues = {
  instalation: 0,
  torniquete: 0,
}

export const accessValidationSchema = Yup.object({
  instalation: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  torniquete: Yup.number().required(FIELD_REQUIRED_MESSAGE),
});

export const accessRegisterInitialValues = {
  instalation: 0,
  torniquete: 0,
  user: 0,
}

export const accessRegisterValidationSchema = Yup.object({
  instalation: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  torniquete: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  user: Yup.number().required(FIELD_REQUIRED_MESSAGE),
});

